import { render, staticRenderFns } from "./Freespee.vue?vue&type=template&id=611ac1e4&"
import script from "./Freespee.vue?vue&type=script&lang=js&"
export * from "./Freespee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports